import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

import { UpcomingMeetingsResponse } from '../../../interfaces/upcoming-meeting.interface';

/**
 * Próximas reuniones del calendario de Google de quien tiene la sesión. El back
 * lee el calendario con permiso de dominio: la persona no conecta nada.
 */
@Injectable({ providedIn: 'root' })
export class UpcomingMeetingsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl =
    environment.integrationsApiGateway + 'integrations/google-workspace/upcoming-meetings';

  getUpcomingMeetings(): Observable<UpcomingMeetingsResponse> {
    return this.http.get<UpcomingMeetingsResponse>(this.apiUrl);
  }
}
